/**
 * LinkedIn Post Service
 *
 * Frontend service for generating LinkedIn posts.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';

export type LinkedInTone = 'thought-leadership' | 'personal-story' | 'lesson-learned' | 'achievement';

export interface LinkedInPostResult {
  post: string;
  hashtags: string[];
}

export async function generateLinkedInPost(
  topic: string,
  tone: LinkedInTone,
  language: string,
  useCareerContext: boolean
): Promise<LinkedInPostResult> {
  const functions = getFunctions();
  const fn = httpsCallable<
    { topic: string; tone: string; language: string; useCareerContext: boolean },
    LinkedInPostResult
  >(functions, 'generateLinkedInPost');
  const result = await fn({ topic, tone, language, useCareerContext });
  return result.data;
}
